import React from 'react';

const SlickSliderLoaderRow = () => (
    <div className="px-1.5 py-3 ">
        <div className="rounded-xl border border-utilityGray200 overflow-hidden bg-white flex flex-col w-[344px]">
            {/* Header: carrier logo + name + order ID */}
            <div className="flex items-center gap-2 px-3 py-3 border-b border-utilityGray200 bg-gray50">
                <div className="w-[32px] h-[32px] min-w-[32px] min-h-[32px] rounded-md custom-loading flex-none" />
                <div className="flex flex-col gap-1 min-w-0 flex-1">
                    <div className="h-[16px] w-28 rounded custom-loading" />
                    <div className="h-[16px] w-20 rounded custom-loading" />
                </div>
            </div>

            {/* Body */}
            <div className="space-y-3 flex-1 px-3 py-3">
                {/* Appointment row with order type badge placeholder */}
                <div className="flex items-center justify-between gap-2">
                    <div className="space-y-1 min-w-0 flex-1">
                        <div className="h-[17px] w-24 rounded custom-loading" />
                        <div className="h-[17px] w-32 rounded custom-loading" />
                    </div>
                    <div className="h-[17px] w-10 rounded custom-loading flex-none" />
                </div>

                {/* Address */}
                <div className="flex flex-col gap-1">
                    <div className="h-[17px] w-20 rounded custom-loading" />
                    <div className="h-[17px] w-36 rounded custom-loading" />
                </div>

                {/* Notes */}
                <div className="flex flex-col gap-1">
                    <div className="h-[17px] w-16 rounded custom-loading" />
                    <div className="h-[17px] w-28 rounded custom-loading" />
                </div>
            </div>

            {/* Footer: status badge */}
            <div className="flex items-center justify-between px-3 py-3 border-t border-utilityGray200">
                <div className="h-[18px] w-20 rounded-md custom-loading" />
            </div>
        </div>
    </div>
);

export default SlickSliderLoaderRow;
